<template>
    <div class="TT-wrapper" v-resize:debounce="onResize">
        <div class="TT-wrapper__carousel">
            <Carousel v-bind:width="window.width"></Carousel>
        </div>
        <div class="TT-wrapper__menu-grid">
            <MenuGrid></MenuGrid>
        </div>
        <div class="TT-wrapper__promo_carousel">
            <PromoCarousel v-bind:width="window.width"></PromoCarousel>
        </div>
        <div class="TT-wrapper__counter-statistics">
            <CounterStatistics></CounterStatistics>
        </div>
        <div class="TT-wrapper__contact">
            <Contact></Contact>
        </div>
    </div>
</template>

<script>
import Carousel from "./client-views/carousel/carouselComponent.vue";
import MenuGrid from "./client-views/menu-grid/menuGridComponent.vue";
import CounterStatistics from "./client-views/counter-stats/counterStatistics.vue";
import Contact from "./client-views/contact/contactComponent.vue";
import Footer from "./client-views/footer/footerComponent.vue";
import PromoCarousel from "./client-views/promoCarousel/promoCarouselComponent.vue";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import resize from "vue-resize-directive";

export default {
    name: "Home",
    components: {
        Carousel,
        MenuGrid,
        CounterStatistics,
        Contact,
        Footer,
        PromoCarousel
    },
    directives: {
        resize
    },
    data() {
        return {
            parallaxTimeline: null,
            window: {
                width: 0,
                height: 0
            }
        };
    },
    created() {},
    methods: {
        onResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
            console.log(this.window.width);
        },
        scrollToHash() {
            const section = this.$router.currentRoute.hash.replace("#", "");
            if (section) {
                const element = document.querySelector(`#${section}`);
                element.scrollIntoView({
                    behavior: "smooth"
                });
            }
        }
    },
    beforeDestroy() {
        // this.parallaxTimeline.kill(true);
    },
    destroyed() {},
    mounted() {
        gsap.registerPlugin(ScrollTrigger);

        // this.parallaxTimeline = gsap.timeline({
        //     scrollTrigger: {
        //         id: "parallax",
        //         trigger: ".TT-wrapper__carousel",
        //         start: "top 80px",
        //         pin: true,
        //         end: () => {
        //             return (
        //                 "+=" +
        //                 (document.querySelector(".TT-wrapper__carousel")
        //                     .offsetHeight -
        //                     30)
        //             );
        //         },
        //         scrub: true
        //     }
        // });

        setTimeout(() => this.scrollToHash(), 100);

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: ".TT-wrapper__menu-grid",
                start: "top 100px",
                markers: false,
                anticipatePin: true
            }
        });
        setTimeout(() => {
            let gridItemsSelector = ".TT-menu-grid__content > div";
            if (window.innerWidth >= 768) {
                gridItemsSelector += ":not(:first-child)";
            }
            timeline
                .to(gridItemsSelector, {
                    x: 20,
                    stagger: 0.1,
                    duration: 0.5,
                    ease: "power2.out"
                })
                .to(
                    gridItemsSelector,
                    {
                        x: 0,
                        scale: 1,
                        stagger: 0.1,
                        duration: 1,
                        ease: "elastic"
                    },
                    "-=0.5"
                );
        }, 2000);
    }
};
</script>
